import { AviTracerApi } from "../avitracerApi"
import { isAnonymousOrganization } from "../models/organization"
import { selectOrganization } from "../store/organizationsSlice"
import { store } from "../store/store"

//Deep links carry no team info: the :orgId placeholder resolves to the last selected team,
//so an entity living in another of the user's teams 404s. On failure, probe the user's other
//teams and switch the selected team when the entity is found there.
export async function fetchSwitchingTeamIfNeeded<T>(fetchFromOrg: (orgId?: string) => Promise<T>): Promise<T> {
    try {
        return await fetchFromOrg(undefined)
    } catch (errorInSelectedTeam) {
        let allOrgs = store.getState().organizations.allOrganizations
        if (allOrgs.length === 0) {
            try {
                allOrgs = await AviTracerApi.getOrganizations()
            } catch {
                throw errorInSelectedTeam
            }
        }

        const selectedOrgId = store.getState().organizations.selectedOrganizationId
        for (const org of allOrgs) {
            if (org.id === selectedOrgId || isAnonymousOrganization(org)) {
                continue
            }
            try {
                const entity = await fetchFromOrg(org.id)
                store.dispatch(selectOrganization(org))
                return entity
            } catch {
                //Not in this team either
            }
        }

        throw errorInSelectedTeam
    }
}
